module.exports = __webpack_public_path__ + "media/images/autopilot_preview-email_only-d-5620a6d13ecb0e88f7c96fb234bb4e42.svg";